import { defaultSubjectGateId } from '../../nats/registry/subject-gate-id.js';
import type { SubjectRegistryApi } from '../../nats/registry/subject-registry.js';
import { isWireEligibleSubject } from '../../nats/wire/filter-manager.js';

/** A row template or domain pin cannot discover records for an empty query. */
export function isPollingSubject(subject: string): boolean {
  return (
    isWireEligibleSubject(subject) &&
    subject.split('.').every((part) => part !== 'undefined' && part !== 'null')
  );
}

export function hasPollingCoverage(
  registry: SubjectRegistryApi | null,
  subjects: readonly string[],
  gatedSubjects: readonly string[] = [],
  gateIdFor?: (subject: string) => string | null | undefined,
): boolean {
  if (registry === null || registry.isWireInterestDisabled?.() === true) return false;
  const gated = gatedSubjects.filter(isPollingSubject);
  const active = gated.filter((subject) => {
    if (registry.acquireEntityGated === undefined) return true;
    const custom = gateIdFor?.(subject);
    const id = custom === undefined ? defaultSubjectGateId(subject) : custom;
    return (
      id === null ||
      registry.isEntityVisibilityTracked?.(id) !== true ||
      registry.isEntityVisible(id)
    );
  });
  const concrete = [...subjects.filter(isPollingSubject), ...active];
  // A deliberately hidden fan-out is idle, not uncovered discovery. Still
  // require an installed wire; an empty/unscoped query must retain polling.
  if (concrete.length === 0)
    return gated.length > 0 && registry.hasConcreteWireInterest?.([]) === true;
  return (
    registry.hasPollingCoverage?.(concrete) ?? registry.hasConcreteWireInterest?.(concrete) ?? false
  );
}
